import { FormattedMessage } from 'react-intl'

import { Anchor } from '~/DesignSystem/components/anchor'

export function FooterContent() {
  return (
    <div className="text-center text-xs text-muted-foreground">
      <FormattedMessage
        id="app.footer.content"
        values={{
          br: <br />,
          link: (
            <Anchor target="_blank" href="https://www.chatecommerce.com/privacy-policy">
              <FormattedMessage id="app.footer.content.privacyPolicy" />
            </Anchor>
          ),
        }}
      />
    </div>
  )
}
